import './bootstrap';

import PageForm from './components/PageForm.vue';
import PageMasterForm from './components/PageMasterForm.vue';
import PageBulkUpdateDatesForm from './components/PageBulkUpdateDatesForm.vue';
import PageStatusForm from './components/PageStatusForm.vue';
import PagesOrderForm from './components/PagesOrderForm.vue';
import OfficeForm from './components/OfficeForm.vue';
import MinistryForm from './components/MinistryForm.vue';
import InstitutionForm from "./components/InstitutionForm.vue";
import ExternalServicesForm from "./components/ExternalServicesForm.vue";
import SuggestionsSettingsForm from "./components/SuggestionsSettingsForm.vue";
import CategoryForm from './components/CategoryForm.vue';
import UserForm from './components/UserForm.vue';
import ProfileForm from './components/ProfileForm.vue';
import OfficesCollapse from './components/OfficesCollapse.vue';
import MobileMenu from './components/MobileMenu.vue';
import PageFilterForm from './components/PageFilterForm.vue';
import AccessTokenForm from './components/AccessTokenForm.vue';
import NotificationForm from './components/NotificationForm.vue';
import PastUsers from './components/PastUsers.vue';
import ContentForm from './components/ContentForm.vue';
import Steps from './components/Steps.vue';
import MessagesModal from './components/MessagesModal.vue';
import TimeAgo from './components/TimeAgo.vue';
import MessageForm from './components/MessageForm.vue';
import MessageList from './components/MessageList.vue';
import ReportForm from './components/ReportForm.vue';
import ReportFilterForm from './components/ReportFilterForm.vue';
import SitemapForm from './components/SitemapForm.vue';
import MessageActionButton from './components/MessageActionButton.vue';
import IconSelect from './components/IconSelect.vue';
import HolidaysForm from './components/HolidaysForm';
import HolidayFormEdit from './components/HolidayFormEdit.vue';
import FormAddAgendamiento from './components/FormAddAgendamiento.vue';
import FormEditAgendamiento from './components/FormEditAgendamiento.vue'

import LandingPageSucursalVirtualComponentDataForm from './components/LandingPageSucursalVirtualComponentDataForm.vue';
import LandingPageSucursalVirtualComponentDataFormEdit from './components/LandingPageSucursalVirtualComponentDataFormEdit.vue';

import ElSwitch from 'element-ui/lib/switch';

import AnnouncementForm from './components/AnnouncementForm.vue';
import HelpCardForm from './components/HelpCardForm.vue';
import SortFaq from './components/SortFaq.vue';
import CampaignForm from './components/CampaignForm.vue';
import CertificateForm from './components/CertificateForm.vue';
import HelpChannelForm from './components/HelpChannelForm.vue';
import SendNotification from './components/SendNotification.vue';

import ReminderForm from './components/ReminderForm.vue';
import ReminderList from './components/ReminderList.vue';

import HitoVidaForm from './components/HitoVidaForm.vue';

import Confirm from './directives/Confirm.js';
import HitoVidaOrderTable from './components/HitoVidaOrderTable.vue';
import SectionhomeForm from './components/SectionhomeForm.vue';
import SectionPageAdminContentsForm from './components/SectionPageAdminContentsForm.vue';
import SectionUrlAdminContentsForm from './components/SectionUrlAdminContentsForm.vue';
import SettingMenuCitizenForm from './components/SettingMenuCitizenForm.vue';
import BannerForm from './components/BannerForm.vue';
import LastNewsForm from './components/LastNewsForm.vue';

import TopicForm from './components/TopicForm.vue';
import FaqsForm from './components/FaqsForm.vue';
import TypeForm from './components/TypeForm.vue';

import TopicQuestionForm from './components/TopicQuestionForm.vue';
import SortFaqTopic from './components/SortFaqTopic.vue';
import SortFaqTopicQuestion from './components/SortFaqTopicQuestion.vue';

import FeaturedPages from './components/FeaturedPages.vue';
import ConsultBenefitForm from './components/ConsultBenefitForm.vue';
import SeoMaintainerForm from './components/SeoMaintainerForm.vue';
import NavBarForm from './components/NavBarForm.vue';
import MenuEditorForm from './components/MenuEditorForm.vue'; 

import StepStageHitoVidaForm from './components/StepStageHitoVidaForm.vue';
import StepStageHitoVidaTableOrderForm from './components/StepStageHitoVidaTableOrderForm.vue'; 
import SuggestRemindersForm from './components/SuggestRemindersForm.vue';
import FormadepagoForm from './components/FormadepagoForm.vue';

import VitrinaPrincipalForm from './components/VitrinaPrincipalForm.vue';
import VitrinaBeneficiosServiciosForm from './components/VitrinaBeneficiosServiciosForm.vue';

import LandingPagesComponentsDataForm from './components/LandingPagesComponentsDataForm.vue';
import LandingPagesComponentsDataFormEdit from './components/LandingPagesComponentsDataFormEdit.vue';

import InputKeywordsForm from './components/InputKeywordsForm.vue';
import Editor from "./components/Editor.vue";
import AlertHorarioEspecialForm from './components/AlertHorarioEspecialForm.vue';
import MassEditionOfficesForm from './components/MassEditionOfficesForm.vue';
import FormAddTramiteSucursalVirtual from './components/FormAddTramiteSucursalVirtual.vue';
import FormEditTramiteSucursalVirtual from './components/FormEditTramiteSucursalVirtual.vue';
import EditOrderComponentsPage from './components/EditOrderComponentsPage.vue';

import ActionForm from './components/ActionForm.vue';
import ChannelForm from './components/ChannelForm.vue';
import LandingCanalesAtencionFicha from './components/LandingCanalesAtencionFicha.vue';
import ChannelRegisterForm from './components/ChannelRegisterForm.vue';

import FooterComponentForm from './components/FooterComponentForm.vue';
import FooterComponentFormEdit from "./components/FooterComponentFormEdit.vue";
import FooterTable from "./components/FooterTable.vue";
import PageActionFormTitle from './components/PageActionFormTitle.vue';
import EditOrderPage from './components/EditOrderPage.vue';
import DescriptionSvForm from "./components/sucursal-virtual/DescriptionSvForm.vue";
import EditorHitoVida from "./components/EditorHitoVida.vue";

import InstitutionSearchByChannels from "./components/InstitutionSearchByChannels.vue";
import HelpChannelImage from "./components/HelpChannelImage.vue";
import HelpChannelShowBack from "./components/HelpChannelShowBack.vue";

import HomeNewDestacamosForm from "./components/HomeNewDestacamosForm.vue";

import HomeNewLoMasBuscadoForm from "./components/HomeNewLoMasBuscadoForm.vue";
import HomeNewPreguntasFrecuentesForm from "./components/HomeNewPreguntasFrecuentesForm.vue";

import RedAtencionHorarioForm from './components/backend/red-atencion/RedAtencionHorarioForm.vue';
import RedAtencionAlertaForm from './components/backend/red-atencion/RedAtencionAlertaForm.vue';

window.leaflet = require('leaflet');
require('leaflet-easybutton');

delete L.Icon.Default.prototype._getIconUrl

L.Icon.Default.mergeOptions({
    iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
    iconUrl: require("leaflet/dist/images/marker-icon.png"),
    shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
})

Vue.prototype.$eventHub = new Vue();

new Vue({
    el: '#app',
    components: {
        PageForm,
        PageMasterForm,
        PageBulkUpdateDatesForm,
        PageStatusForm,
        PagesOrderForm,
        OfficesCollapse,
        MobileMenu,
        UserForm,
        ProfileForm,
        OfficeForm,
        MinistryForm,
        InstitutionForm,
        ExternalServicesForm,
        SuggestionsSettingsForm,
        CategoryForm,
        PageFilterForm,
        AccessTokenForm,
        NotificationForm,
        PastUsers,
        ContentForm,
        Steps,
        MessagesModal,
        TimeAgo,
        MessageForm,
        MessageList,
        ReportForm,
        ReportFilterForm,
        SitemapForm,
        MessageActionButton,
        AnnouncementForm,
        HelpCardForm,
        SortFaq,
        ElSwitch,
        IconSelect,
        CampaignForm,
        CertificateForm,
        HelpChannelForm,
        SendNotification,
        ReminderForm,
        ReminderList,
        HitoVidaForm,
        HitoVidaOrderTable,
        SectionhomeForm,
        SectionPageAdminContentsForm,
        SectionUrlAdminContentsForm,
        SettingMenuCitizenForm,
        BannerForm,
        LastNewsForm,
        TopicForm,
        FaqsForm,
        TypeForm,
        TopicQuestionForm,
        SortFaqTopic,
        SortFaqTopicQuestion,
        FeaturedPages,
        ConsultBenefitForm,
        SeoMaintainerForm,
        MenuEditorForm,
        NavBarForm ,
        StepStageHitoVidaForm,
        StepStageHitoVidaTableOrderForm,
        SuggestRemindersForm,
        FormadepagoForm,
        VitrinaPrincipalForm,
        VitrinaBeneficiosServiciosForm,
        FormadepagoForm,
        LandingPagesComponentsDataForm,
        LandingPagesComponentsDataFormEdit,
        InputKeywordsForm,
        Editor,
        AlertHorarioEspecialForm,
        MassEditionOfficesForm,
        FormAddTramiteSucursalVirtual,
        FormEditTramiteSucursalVirtual,
        EditOrderComponentsPage,
        ActionForm,
        ChannelForm,
        HolidaysForm,
        HolidayFormEdit,
        LandingCanalesAtencionFicha,
        ChannelRegisterForm,
        FormAddAgendamiento,
        FormEditAgendamiento,
        FooterComponentForm,
        FooterTable,
        FooterComponentFormEdit,
        PageActionFormTitle,
        LandingPageSucursalVirtualComponentDataForm,
        LandingPageSucursalVirtualComponentDataFormEdit,
        EditOrderPage,
        DescriptionSvForm,
        EditorHitoVida,
        InstitutionSearchByChannels,
        HelpChannelImage,
        HelpChannelShowBack,
        HomeNewDestacamosForm,
        HomeNewLoMasBuscadoForm,
        HomeNewPreguntasFrecuentesForm,
        RedAtencionHorarioForm,
        RedAtencionAlertaForm
    },
    directives:{
        Confirm
    },
    methods:{
        moment: moment
    },
    mounted() {
        $('[data-toggle="tooltip"]').tooltip();
    }
});
